import React, { useEffect, useState } from "react";
import PlusIcon from "assets/icon/PlusIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, FormTypeAdd, FormTypeEdit, PageSize, StatusCodeActive } from "utils/Constant";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers"
import Pagination from "components/Input/PaginationButton";
import { FilterCard, MainBodyCard, PagesTitle } from "components/Cards";
import { useModal } from "context/ModalContext";
import { BrandService } from "services/BrandService/BrandService";
import GridDeleteButton from "components/Button/GridDeleteButton";
import DataTable from "components/DataTable";
import AddButton from "components/Button/AddButton";

export default function Brand(){
    let navigate = useNavigate()
    
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchBrandList, fetchDeleteBrand } = BrandService()

    const [brandName, setBrandName] = useState('')
    const [brandList, setBrandList] = useState([])
    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const columns = [
        {
            key: "rowNumber",
            header: "No",
            headerClassName: "w-16 font-semibold",
            cellClassName: "text-center",
        },
        {
            key: "brandName",
            header: "Brand"
        },
        {
            key: "status",
            header: "Status",
            render: (row) => GetStatus(row.status),
        },
        {
            key: "action",
            header: "Action",
            render: (row) => (
                <div className="flex gap-2">
                    <GridDeleteButton isActive={row.status} onClick={() => deleteBtnClick(row.salesStockId, row.status)} size="w-3" />
                </div>                
            ),
        },
    ]

    // Button Event
    const addBtnClick = () => {
        navigate("/brand/form?brandId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (id) => {
        navigate("/brand/form?brandId=" + id + "&formType=" + FormTypeEdit)
    }
    const deleteBtnClick = async (id, status) => {
        const onConfirm = await confirm()

        if (!onConfirm) return

        showLoading()

        try {
            let res = await fetchDeleteBrand(id, status)
            if (!res) return

            showSuccess({
                onSuccess: () => {
                    handlePageChange(pageIndex)
                }
            })
        }
        finally {
            hideLoading()
        }
    }

    // Function Grid
    async function handlePageChange(newIndex) {
        showLoading()

        try {
            const res = await fetchBrandList(brandName, status, PageSize, newIndex)
            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setBrandList(res)
            setTotalPages(total);
            setPageIndex(newIndex);
        } finally {
            hideLoading()
        }
    }

    useEffect(() => {        
        handlePageChange(0)
    },[brandName, status])

    return(
        <MainBodyCard>
            <PagesTitle title='Brand' />

            <div className="flex flex-col sm:flex-row justify-between gap-8 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <FilterCard title='Brand Name' width='w-full sm:w-[280px]'>
                        <input className="input" value={brandName} onChange={(e) => { setBrandName(e.target.value) }} />
                    </FilterCard>
                    <FilterCard title='Status' width='w-full sm:w-[120px]'>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => { setStatus(e.value) }} placeholder={"All"} />
                    </FilterCard>
                </div>
            </div>

            <div className="flex w-full justify-end mt-4">
                <AddButton onClick={addBtnClick} text='Tambah Brand' />
            </div>
        
            <div className="mt-5">
                <DataTable
                    columns={columns}
                    data={brandList?.data?.listData ?? []}
                />
            </div>

            <Pagination
                pageIndex={pageIndex}
                totalPages={totalPages}
                onPageChange={handlePageChange}
            />
        </MainBodyCard>
        
    )
}